import angular from 'angular'
import ovatBillModalCtrl from './ovatBillModalCtrl'
import importOvatBillModalContentCtrl from './importOvatBillModalContentCtrl'
import ovatBillChangeUkeyModalCtrl from './ovatBillChangeUkeyModalCtrl'
import splitBillRuleModalCtrl from './splitBillRuleModalCtrl'
import chooseInvoiceNoCtrl from './chooseInvoiceNoCtrl'
import splitDetailColModCtrl from './splitDetailColModCtrl'
import spiltBillCommitModCtrl from './spiltBillCommitModCtrl'
import splitResultCtrl from './splitResultCtrl'

import {
    ovatBillRouter,
    ovatBillListCtrlRouter,
    billDetailListCtrlRouter,
    checkBillDetailCtrlRouter,
    billPreviewCtrlRouter,
    spiltBillDetailListCtrlRouter,
    dataCollectionRouter,
    relatedInvoiceDetailRouter,
    relatedVehicleDetailRouter,
    relatedRollDetailRouter,
} from './Routers'

import { ovatBill, openedInvoice, vehicleInvoice } from 'redevConfig'

const list = (ovatBill && ovatBill.list) || ''
const detailList = (ovatBill && ovatBill.detailList) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const dataCollection = (ovatBill && ovatBill.dataCollection) || ''
const billPreview = (ovatBill && ovatBill.billPreview) || ''
const openedInvoiceDetail = (openedInvoice && openedInvoice.detail) || ''
const vehicleInvoiceAdd = (vehicleInvoice && vehicleInvoice.add) || ''
const rollDetail = (openedInvoice && openedInvoice.rollDetail) || ''

const ovatBillListCtrl = list ? require(`redevelopment/outputManage/ovatBill/${list.controllerName}`) : require('./ovatBillListCtrl')
const billDetailListCtrl = detailList ? require(`redevelopment/outputManage/ovatBill/${detailList.controllerName}`) : require('./billDetailListCtrl')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.controllerName}`) : require('./checkBillDetailCtrl')
const dataCollectionCtrl = dataCollection ? require(`redevelopment/outputManage/ovatBill/${dataCollection.controllerName}`) : require('./dataCollectionCtrl')
const billPreviewCtrl = billPreview ? require(`redevelopment/outputManage/ovatBill/${billPreview.controllerName}`) : require('./billPreviewCtrl')
const openedInvoiceDetailCtrl = openedInvoiceDetail ? require(`redevelopment/outputManage/openedInvoice/${detail.controllerName}`) : require('app/outputManage/billManage/openedInvoice/openedInvoiceDetailCtrl')
const vehicleDetailCtrl = vehicleInvoiceAdd ? require(`redevelopment/outputManage/vehicleInvoice/${vehicleInvoiceAdd.controllerName}`) : require('app/outputManage/fillOpenManage/vehicleInvoice/add')
const rollDetailCtrl = rollDetail ? require(`redevelopment/outputManage/openedInvoice/${rollDetail.controllerName}`) : require('app/outputManage/billManage/openedInvoice/rollDetailCtrl')


export default angular
    .module('outputManage.FOManage.ovatBill', [])
    .config(['$stateProvider', config])
    .controller('ovatBillListCtrl', ovatBillListCtrl.default)
    .controller('billDetailListCtrl', billDetailListCtrl.default)
    .controller('checkBillDetailCtrl', checkBillDetailCtrl.default)
    .controller('billPreviewCtrl', billPreviewCtrl.default)
    .controller('splitResultCtrl', splitResultCtrl)
    .controller('ovatBillModalCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', 'invoiceOpenService', ovatBillModalCtrl])
    .controller('ovatBillChangeUkeyModalCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', ovatBillChangeUkeyModalCtrl])
    .controller('importOvatBillModalContentCtrl', importOvatBillModalContentCtrl)
    .controller('splitBillRuleModalCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'resultTipService', '$timeout', splitBillRuleModalCtrl])
    .controller('chooseInvoiceNoCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', '$state', 'globalFn', chooseInvoiceNoCtrl])
    .controller('splitDetailColModCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', 'globalFn', splitDetailColModCtrl])
    .controller('spiltBillCommitModCtrl', ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'Upload', '$timeout', '$rootScope', '$uibModal', 'globalFn', '$location', '$state', spiltBillCommitModCtrl])
    .controller('dataCollectionCtrl', dataCollectionCtrl.default)
    .controller('openedInvoiceDetailCtrl', openedInvoiceDetailCtrl.default)
    .controller('vehicleDetailCtrl', vehicleDetailCtrl.default)
    .controller('rollDetailCtrl', rollDetailCtrl.default)
    .name

function config ($stateProvider) {
    // 'ngInject';
    $stateProvider
        .state(ovatBillRouter.state, ovatBillRouter.config)
        .state(ovatBillListCtrlRouter.state, ovatBillListCtrlRouter.config)
        .state(billDetailListCtrlRouter.state, billDetailListCtrlRouter.config)
        .state(checkBillDetailCtrlRouter.state, checkBillDetailCtrlRouter.config)
        .state(billPreviewCtrlRouter.state, billPreviewCtrlRouter.config)
        .state(spiltBillDetailListCtrlRouter.state, spiltBillDetailListCtrlRouter.config)
        .state(dataCollectionRouter.state, dataCollectionRouter.config)
        .state(relatedInvoiceDetailRouter.state, relatedInvoiceDetailRouter.config)
        .state(relatedVehicleDetailRouter.state, relatedVehicleDetailRouter.config)
        .state(relatedRollDetailRouter.state, relatedRollDetailRouter.config)
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/index.js